const columns = [
  {
    name: 'First Name',
    selector: (row) => row['First Name'],
    sortable: true,
  },
  {
    name: 'Last Name',
    selector: (row) => row['Last Name'],
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row['Work Email'],
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.status,
    sortable: true,
  },
];

export default columns;
